module.exports = __webpack_public_path__ + "img/block-1920.229d9925.jpg";